export const baseFilters = {
  cities: [],
  countries: [],
  category: undefined,
  sub_category: undefined,
  min_price: undefined,
  max_price: undefined,
};
